/* ==========================================================================
   PROJECTS CATEGORY FILTER MODULE
   ========================================================================== */

export function initProjectFilters() {
  const filterPills = document.querySelectorAll('.project-filter-pill');
  const caseCards = document.querySelectorAll('.case-card');

  if (!filterPills.length || !caseCards.length) return;

  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      filterPills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      const filterCategory = pill.dataset.filter;

      caseCards.forEach(card => {
        const cardCategory = card.dataset.category;

        if (filterCategory === 'all' || cardCategory === filterCategory) {
          card.classList.remove('hidden');
          card.style.opacity = '0';
          card.style.transform = 'translateY(16px)';

          setTimeout(() => {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          }, 50);
        } else {
          card.classList.add('hidden');
        }
      });
    });
  });
}
